import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { TopClickTip } from 'ui/popover';
import { Link } from 'ui/links';
import { pxToRem } from 'utils/convert';
import { OptimizeRangeTooltipText } from './Optimize.constants';
import { Body2Light } from '../Content.styles';

const Wrapper = styled.div`
  align-items: center;
  display: inline-flex;
  gap: ${spacing.quarter};
`;

const LinkSmall = styled(Link)`
  font-size: ${pxToRem(14)};
`;

export const OptimizeFormLabel = () => {
  return (
    <Wrapper>
      <span>Frequency optimization range</span>
      <TopClickTip
        popoverContentTitle=""
        popoverContentBody={
          <div>
            <Body2Light>{OptimizeRangeTooltipText}</Body2Light>
            <LinkSmall
              href="https://support.iterable.com/hc/articles/28145709731348"
              target="_blank"
            >
              Learn more
            </LinkSmall>
          </div>
        }
      />
    </Wrapper>
  );
};
